module.exports = __webpack_public_path__ + "static/media/help.e7d5787b.svg";